/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_VEHICLE_REQUEST, RESET_VEHICLE_REQUEST } from '../actions/vehicleActions';


const initialState = {
  vehicles: {}
};

const vehicleReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_VEHICLE_REQUEST:
    case RESET_VEHICLE_REQUEST: {
      const { vehicles } = action.payload;
      return produce(state, (draft) => {
        draft.vehicles = vehicles;
      });
    }

    default: {
      return state;
    }
  }
};

export default vehicleReducer;
